import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowLeft, CheckCircle, WhatsappLogo } from "@phosphor-icons/react";
import SEO from "@/components/SEO";
import Header from "@/components/Header";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import { contactInfo, services } from "@/data/siteContent";

const benefits = ["Ücretsiz ön görüşme", "Planlı ekip ve araç yönlendirme", "Kırıkhan ve Hatay geneli hızlı destek", "Eşya güvenliğine odaklı taşıma"];

export default function ServiceDetail() {
  const { slug } = useParams();
  const service = services.find((item) => item.slug === slug);

  if (!service) return <Navigate to="/" replace />;

  const path = `/hizmetler/${service.slug}`;

  return (
    <main data-testid="service-detail-page" className="min-h-screen bg-[#0A0A0B] text-white">
      <SEO title={service.seoTitle} description={service.seoDescription} path={path} image={service.image} schemaType="Service" />
      <Header />
      <section data-testid="service-detail-hero" className="relative overflow-hidden px-6 pb-20 pt-36 lg:px-8 lg:pb-28 lg:pt-44">
        <img data-testid="service-detail-image" src={service.image} alt={`Has Kırıkhan Nakliyat ${service.title} Kırıkhan Hatay detay görseli`} className="absolute inset-0 h-full w-full object-cover opacity-35" />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/35" />
        <div className="relative mx-auto max-w-5xl">
          <Link data-testid="service-detail-back-link" to="/" className="mb-8 inline-flex items-center gap-2 text-sm font-black text-orange-400 transition-colors duration-300 hover:text-orange-300">
            <ArrowLeft size={18} weight="bold" /> Ana sayfaya dön
          </Link>
          <p data-testid="service-detail-overline" className="text-xs font-black uppercase tracking-[0.22em] text-orange-500">Has Kırıkhan Nakliyat Hizmeti</p>
          <h1 data-testid="service-detail-h1" className="mt-4 font-heading text-4xl font-black tracking-tight text-white sm:text-5xl lg:text-6xl">
            Kırıkhan {service.title}
          </h1>
          <p data-testid="service-detail-description" className="mt-6 max-w-3xl text-base leading-relaxed text-slate-300 md:text-lg">{service.seoDescription}</p>
          <div data-testid="service-detail-cta-row" className="mt-9 flex flex-col gap-4 sm:flex-row">
            <a data-testid="service-detail-whatsapp-button" href={contactInfo.whatsappHref} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-3 rounded-xl bg-[#25D366] px-7 py-4 font-black text-white transition-[transform,background-color,box-shadow] duration-300 hover:-translate-y-1 hover:bg-[#1DA851] hover:shadow-[0_8px_30px_rgba(37,211,102,0.25)]">
              <WhatsappLogo size={22} weight="bold" /> WhatsApp ile teklif al
            </a>
            <a data-testid="service-detail-call-button" href={contactInfo.phoneHref} className="inline-flex items-center justify-center rounded-xl bg-orange-500 px-7 py-4 font-black text-white transition-[transform,background-color,box-shadow] duration-300 hover:-translate-y-1 hover:bg-orange-600 hover:shadow-[0_8px_30px_rgba(249,115,22,0.3)]">
              {contactInfo.phoneDisplay}
            </a>
          </div>
        </div>
      </section>
      <section data-testid="service-detail-benefits" className="px-6 py-20 lg:px-8">
        <div className="mx-auto grid max-w-5xl gap-5 md:grid-cols-2">
          {benefits.map((benefit) => (
            <div key={benefit} data-testid={`service-benefit-${benefit.toLowerCase().replaceAll(" ", "-")}`} className="flex items-center gap-4 rounded-2xl border border-white/10 bg-[#121214] p-5 text-slate-200">
              <CheckCircle size={24} weight="fill" className="text-orange-500" /> {benefit}
            </div>
          ))}
        </div>
      </section>
      <ContactSection />
      <Footer />
    </main>
  );
}